import React, { useEffect } from 'react';
import { Target } from 'components/features/target-achievement-support/utils/type';
import { targetTypeToIconImg } from 'components/features/target-achievement-support/utils/targetInfo';
import { calculateRemainTargetDate } from 'components/features/target-achievement-support/utils/birthday';
import { useGlobalMenuContext } from 'contexts/GlobalMenuContext';
import { useCustomizeHeaderContext } from 'contexts/CustomizeHeaderContext';
import { formatNumber } from 'utils/formatter';
import {
  ContextMenu,
  ContextMenuContainer,
  ContextMenuRow,
  getTargetContextMenuRows,
} from '../../index/ContextMenu';

type Props = {
  target: Target;
  birthday: Date;
  isShowRemainDate: boolean;
  updateTarget: () => void;
  editTitle: () => void;
  endTarget: () => void;
};

export const TargetInformationBasic = ({
  target,
  birthday,
  isShowRemainDate,
  updateTarget,
  editTitle,
  endTarget,
}: Props): React.ReactElement => {
  const { age, month, year } = calculateRemainTargetDate({
    birthday,
    targetDate: new Date(target.endDate),
  });
  const [isOpen, setIsOpen] = React.useState(false);
  const hide = (): void => setIsOpen(false);
  const toggle = (): void => setIsOpen(prev => !prev);

  const { setIsShowMenu } = useGlobalMenuContext();
  const { setWithBell, setWithNavigation } = useCustomizeHeaderContext();

  useEffect(() => {
    return setIsShowMenu(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return setWithBell();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return setWithNavigation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="px-4 pt-4 pb-2">
        <div className="flex flex-row items-center">
          <div>
            <img
              src={targetTypeToIconImg(target.refType)}
              alt="目標アイコン"
              className="w-12 h-12 rounded-full border"
              style={{ borderColor: '#dee5ee', objectFit: 'cover' }}
            />
          </div>
          <div className="ml-2 mr-auto">
            <div className="text-base font-bold text-bluegray-700">
              {target.title}
            </div>
            <div className="text-sm text-bluegray-700">
              目標金額：
              <span className="text-base">
                {formatNumber(target.targetAmount / 10000, {})}
              </span>
              万円
            </div>
          </div>
          <div className="flex flex-col relative justify-start mb-auto z-10 cursor-pointer">
            <ContextMenu
              {...{
                isOpen,
                onClick: toggle,
                onBlur: hide,
              }}>
              <ContextMenuContainer>
                {getTargetContextMenuRows({
                  updateTarget,
                  editTitle,
                  endTarget,
                }).map((row, i) => {
                  return <ContextMenuRow {...row} key={i} />;
                })}
              </ContextMenuContainer>
            </ContextMenu>
          </div>
        </div>
        {isShowRemainDate && (
          <div className="z-0 relative flex flex-row mt-2">
            <div className="py-1 px-3 bg-white border border-bluegray-300 relative ml-auto rounded">
              <div
                className="border-b border-r border-bluegray-300 bg-white w-2 h-2 absolute"
                style={{
                  transform: 'rotate(45deg)',
                  right: '3rem',
                  top: '1.25rem',
                  zIndex: 10,
                }}></div>
              <div className="z-20 rounded bg-white absolute right-0 top-0 left-0 bottom-0"></div>
              <div className="flex flex-row items-center text-gray-700 text-xs h-4 z-30">
                <div className="z-20">目標まであと</div>
                <div className="ml-3 z-20">
                  {year ? `${year}年` : ''}
                  {month ? `${month}ヶ月` : ''}（{age}歳）
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
